import React from 'react';
import {Link} from 'react-router-dom';
import {
    Card, CardBlock, CardGroup, Button,
    ListGroup, ListGroupItem
} from 'reactstrap';


import {api, request, API_URL,url_firma} from '../../actions/_request';

import FaPaperplaneO from 'react-icons/lib/fa/paper-plane-o';
import swal from 'sweetalert2';
class Term extends React.Component {

	constructor(props) {

		super(props)

		this.state = {
			ticket: { cliente: {}},
			cliente: null,

		};
		this.sendEmail 		= this.sendEmail.bind(this);
	}

	componentDidMount() {


		let self = this;
		const {params} = this.props.match;

		if(params.id) {
			api().get('/ticketsv2/'+params.id).then((response) => {

				if(response.status === 200) {

					let data = response.data;

					self.cliente = data.cliente;

					self.setState({ticket: data.ticket});

				}

			});
		}

	}

	sendEmail() {
		let {ticket} = this.state;
		let self=this;
		var iframe = document.getElementById( "iframe1" );
		 var ifrDocument = iframe.contentDocument || iframe.contentWindow.document;
		 var firma = ifrDocument.getElementById( "txt_imagen" );
		
		 // console.log('txt_imagen',firma.value)

		                api().post('/enviarComprobante', { 
		                	firma: firma.value,
							ticketid: ticket.id,
							opcion:'noAprobado'})
						.then(function(response)
			            {    
		                     // console.log('aqui tiene que entrar');
		                   	 window.open(API_URL+"/ticketsv2/printNoAprobado/"+ticket.id);
	                         self.props.history.push('/tickets/ver/'+ticket.id);			                
			            })
						.catch( error => {
							swal.showValidationError(`Solicitar Ayuda a un Administrador`);
						});



		 
		
		
   
		
	}

	mensaje() {
		// let {ticket} = this.state;

		// this.props.history.push('/tickets/ver/'+ticket.id);
		// var el = document.getElementById('targetFrame');
		swal('Error', "Firma Vacia",'error');


    // document.getElementById('iframe1').contentWindow.alerta('Esta alerta del iframe se llamó desde afuera del iframe');
		
	}

 tunnel(fn) {
    fn();
}

	render() {

		const {ticket} = this.state;

		return (

		        <div className="view-content mt-3">
		           <div className="row mb-4 justify-content-center align-items-center">
						<div className="col-9 col-md-9">
		            <Card className="mb-3 invoice-card">
		            <CardBlock>
		                    <div className="d-flex justify-content-between flex-wrap">
		                        <span style={{color: '#ED0303', fontSize: '27px'}}>Maxicomm</span>
		                        <div>
		                            <h4 className="text-uppercase">Ticket</h4>
		                            <h6>clave: {ticket.clave || '-'}</h6>
		                            <small>Fecha: {ticket.fecha_ticket || '-'}</small>
		                        </div>
		                    </div>
		                    <hr/>
		                    <CardGroup>
		                        <Card>
		                            <CardBlock>
		                                <u>Cancelación del Ticket:</u>
										<br/><br/><u>Descripción:</u><br/>
										<span dangerouslySetInnerHTML={{__html: ticket.motivo || '-'}} />
		                            </CardBlock>
		                        </Card>
		                    </CardGroup>
		                     <hr/>

		                     
		                	<br/><br/>

		                	<Link id="Boton_regresar_ticket_firma" to={`/tickets/ver/`+ticket.id}>
	                            <Button color="secondary" className="btn-sm  d-none" >
	                                Regresar
	                            </Button>
	                         </Link>

	                         
	                            <Button color="secondary" className="btn-sm  d-none" id="Boton_guardar_ticket_firma" onClick={this.sendEmail}>
	                                Guardar
	                            </Button>
	                             <Button color="secondary" className="btn-sm  d-none" id="Boton_Menaje_ticket_firma" onClick={this.mensaje}>
	                                Mensaje
	                            </Button>
		                    </CardBlock>		                
		            </Card>
		            </div>
		                    </div>

		        </div>
		)
	}

}


export default Term


// WEBPACK FOOTER //
// ./src/views/ticket/noAprobada.js